
// React Imports
import * as React from "react";
import {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import {
    DataGrid,
    GridToolbarColumnsButton,
    GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport,
    GridToolbarFilterButton
} from '@mui/x-data-grid';
import Box from "@mui/material/Box";
import {
    Avatar,
    Dialog,
    DialogActions,
    DialogContent, DialogContentText,
    DialogTitle,
    InputLabel,
    ListItemIcon,
    ListItemText,
    Menu,
    Select,
    Stack,
    Tooltip
} from "@mui/material";

// App Imports

import {
    stakeholderListSearch, deleteStakeholderList,
    getFileIds, processStakeholderList
} from "./StakeholderListClient";
import CustomFooter from "../../CommonComponents/GridCustomFooter";
import CrudSnackbar from "../../CommonComponents/CrudSnackbar";
import Button from "@mui/material/Button";
import UploadFileDrawer from "../../CommonComponents/UploadFile/UploadFileDrawer";
import {changeUploadFile} from "../../CommonComponents/UploadFile/uploadFileSlice";
import SearchIcon from "@mui/icons-material/Search";
import StakeholderListSearch from "./StakeholderListSearch";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import LinearIndeterminate from "../../CommonComponents/Progress";
import EditIcon from "@mui/icons-material/Edit";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import IconButton from "@mui/material/IconButton";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {changeCrudSnackbar} from "../../CommonComponents/crudSnackbarSlice";
import StakeholderListDrawer from "./StakeholderListDrawer";
import {changeStakeholderList} from "./stakeholderListSlice";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import AddFiltersExportToolbar from "../../CommonComponents/AddFiltersExportToolbar";
// import {StakeholderListGridColumns} from "../StakeholderList/StakeholderListGridColumns";
// import {changeStakeholderList} from "../StakeholderList/stakeholderListSlice";
import {StakeholderListGridColumns} from "./StakeholderListGridColumns";
import {deleteFinancial} from "../Financial/FinancialClient";
import {changeFinancial} from "../Financial/financialSlice";
import {changeExternalData} from "../externalDataSlice";
import NoSearchCriteriaSnackbar from "../../CommonComponents/NoSearchCriteriaSnackbar";
import StakeholderListInfoDialogue from "./Info/StakeholderListInfoDialogue";



// main function
export default function StakeholderListGrid() {

    // ****************** BEGIN STATES ****************************

    const [stakeholderLists, setStakeholderLists] = useState([]);
    const [gridVisible, setGridVisible] = React.useState(true);
    const [showControls, setShowControls] = useState(true);
    const [showSearch, setShowSearch] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const hideActions = localStorage.getItem('hideActions') === "true";

    const selectorId = useSelector((state) => state.stakeholderListSearchSlc.value.id);
    const selectorFileId = useSelector((state) => state.stakeholderListSearchSlc.value.fileId);
    const selectorRecordId = useSelector((state) => state.stakeholderListSearchSlc.value.recordId);
    const selectorProductId = useSelector((state) => state.stakeholderListSearchSlc.value.productId);
    const selectorProductName = useSelector((state) => state.stakeholderListSearchSlc.value.productName);
    const selectorEpisodeName = useSelector((state) => state.stakeholderListSearchSlc.value.episodeName);
    const selectorPhotoStartDateFrom = useSelector((state) => state.stakeholderListSearchSlc.value.photoStartDateFrom);
    const selectorPhotoStartDateTo = useSelector((state) => state.stakeholderListSearchSlc.value.photoStartDateTo);
    const selectorSeriesExternalId = useSelector((state) => state.stakeholderListSearchSlc.value.seriesExternalId);
    const selectorSeriesName = useSelector((state) => state.stakeholderListSearchSlc.value.seriesName);
    const selectorSeasonExternalId = useSelector((state) => state.stakeholderListSearchSlc.value.seasonExternalId);
    const selectorSeasonNumberFrom = useSelector((state) => state.stakeholderListSearchSlc.value.seasonNumberFrom);
    const selectorSeasonNumberTo = useSelector((state) => state.stakeholderListSearchSlc.value.seasonNumberTo);
    const selectorSeasonName = useSelector((state) => state.stakeholderListSearchSlc.value.seasonName);

    const selectorGuild = useSelector((state) => state.stakeholderListSearchSlc.value.guild);
    const selectorFsoId = useSelector((state) => state.stakeholderListSearchSlc.value.fsoId);
    const selectorFsoTaxId = useSelector((state) => state.stakeholderListSearchSlc.value.fsoTaxId);
    const selectorFsoFirstName = useSelector((state) => state.stakeholderListSearchSlc.value.fsoFirstName);
    const selectorFsoLastName = useSelector((state) => state.stakeholderListSearchSlc.value.fsoLastName);
    const selectorFsoSuffix = useSelector((state) => state.stakeholderListSearchSlc.value.fsoSuffix);

    const selectorContractedPartyId = useSelector((state) => state.stakeholderListSearchSlc.value.contractedPartyId);
    const selectorContractedPartyTaxId = useSelector((state) => state.stakeholderListSearchSlc.value.contractedPartyTaxId);
    const selectorContractedPartyFirstName = useSelector((state) => state.stakeholderListSearchSlc.value.contractedPartyFirstName);
    const selectorContractedPartyLastName = useSelector((state) => state.stakeholderListSearchSlc.value.contractedPartyLastName);
    const selectorContractedPartySuffix = useSelector((state) => state.stakeholderListSearchSlc.value.contractedPartySuffix);
    const selectorContractedPartyCompanyName = useSelector((state) => state.stakeholderListSearchSlc.value.contractedPartyCompanyName);

    const selectorPayeeId = useSelector((state) => state.stakeholderListSearchSlc.value.payeeId);
    const selectorPayeeTaxId = useSelector((state) => state.stakeholderListSearchSlc.value.payeeTaxId);
    const selectorPayeeFirstName = useSelector((state) => state.stakeholderListSearchSlc.value.payeeFirstName);
    const selectorPayeeLastName = useSelector((state) => state.stakeholderListSearchSlc.value.payeeLastName);
    const selectorPayeeSuffix = useSelector((state) => state.stakeholderListSearchSlc.value.payeeSuffix);
    const selectorPayeeCompanyName = useSelector((state) => state.stakeholderListSearchSlc.value.payeeCompanyName);

    const selectorJobCode = useSelector((state) => state.stakeholderListSearchSlc.value.jobCode);
    const selectorContractLength = useSelector((state) => state.stakeholderListSearchSlc.value.contractLength);
    const [fileIdDropdown, setFileIdDropdown] = useState([]);
    const [selectedFileId, setSelectedFileId] = useState([]);

    const selectorParticipations = useSelector((state) => state.stakeholderListSearchSlc.value.participations);
    const selectorResiduals = useSelector((state) => state.stakeholderListSearchSlc.value.residuals);
    const selectorRoyalties = useSelector((state) => state.stakeholderListSearchSlc.value.royalties);

    const selectedId = useSelector((state) => state.stakeholderListSlc.value.id);

    const [deleteOpen, setDeleteOpen] = React.useState(false);
    const selectorUploadFileDrawerState = useSelector((state) => state.uploadFileSlc.value.uploadFileDrawerState);

    const selectorDrawerState = useSelector((state) => state.stakeholderListSlc.value.stakeholderListDrawerState);
    // ****************** END STATES ****************************


    // *********************** BEGIN STORE ********************************

    const dispatchData = useDispatch();

    const selectorStakeholderListGridRefresh = useSelector((state) => state.stakeholderListSlc.value.stakeholderListGridRefresh);

    const [stakeholderListInfoOpen, setStakeholderListInfoOpen] = useState(false);

    // ********************** END STORE ********************************


    // ****************** BEGIN FETCH ****************************
    //
    // const fetchStakeholderLists = () => {
    //     console.log("fetch");
    //     if (
    //         (selectorFileId !== "" && selectorFileId !== null) ||
    //         (selectorRecordId !== "" &&  selectorRecordId !== null) ||
    //         (selectorProductId !== "" &&  selectorProductId !== null) ||
    //         (selectorProductName !== "" &&  selectorProductName !== null) ||
    //         (selectorEpisodeName  !== "" &&   selectorEpisodeName !== null) ||
    //         (selectorPhotoStartDateFrom !== "" &&    selectorPhotoStartDateFrom !== null) ||
    //         (selectorPhotoStartDateTo !== "" &&     selectorPhotoStartDateTo !== null) ||
    //         (selectorSeriesExternalId  !== "" &&    selectorSeriesExternalId !== null) ||
    //         (selectorSeriesName  !== "" &&    selectorSeriesName !== null) ||
    //         (selectorSeasonExternalId  !== "" &&    selectorSeasonExternalId !== null) ||
    //         (selectorSeasonNumberFrom  !== "" &&    selectorSeasonNumberFrom !== null) ||
    //         (selectorSeasonNumberTo !== "" &&    selectorSeasonNumberTo !== null) ||
    //         (selectorSeasonName  !== "" &&    selectorSeasonName !== null) ||
    //         (selectorGuild  !== "" &&  selectorGuild !== null) ||
    //         (selectorFsoId    !== "" &&  selectorFsoId !== null) ||
    //         (selectorFsoTaxId    !== "" &&   selectorFsoTaxId !== null) ||
    //         (selectorFsoFirstName  !== "" &&   selectorFsoFirstName !== null) ||
    //         (selectorFsoLastName    !== "" &&  selectorFsoLastName !== null) ||
    //         (selectorFsoSuffix  !== "" &&   selectorFsoSuffix !== null) ||
    //         (selectorContractedPartyId  !== "" &&   selectorContractedPartyId !== null) ||
    //         (selectorContractedPartyTaxId  !== "" &&   selectorContractedPartyTaxId !== null) ||
    //         (selectorContractedPartyFirstName  !== "" &&    selectorContractedPartyFirstName !== null) ||
    //         (selectorContractedPartyLastName  !== "" &&    selectorContractedPartyLastName !== null) ||
    //         (selectorContractedPartySuffix  !== "" &&    selectorContractedPartySuffix !== null) ||
    //         (selectorContractedPartyCompanyName  !== "" &&   selectorContractedPartyCompanyName !== null) ||
    //         (selectorPayeeId   !== "" &&   selectorPayeeId !== null) ||
    //         (selectorPayeeTaxId  !== "" &&    selectorPayeeTaxId !== null) ||
    //         (selectorPayeeFirstName   !== "" &&    selectorPayeeFirstName !== null) ||
    //         (selectorPayeeLastName !== "" &&     selectorPayeeLastName !== null) ||
    //         (selectorPayeeSuffix   !== "" &&   selectorPayeeSuffix !== null) ||
    //         (selectorPayeeCompanyName  !== "" &&    selectorPayeeCompanyName !== null) ||
    //         (selectorJobCode    !== "" &&   selectorJobCode !== null) ||
    //         (selectorContractLength  !== "" && selectorContractLength !== null) ||
    //         (selectorParticipations  !== "" && selectorParticipations !== null) ||
    //         (selectorResiduals !== "" &&  selectorResiduals !== null) ||
    //         (selectorRoyalties !== "" &&  selectorRoyalties !== null)
    //     ) {
    //         {
    //             setSubmitting(true);
    //             stakeholderListSearch(
    //                 selectorFileId,
    //                 selectorRecordId,
    //                 selectorProductId,
    //                 selectorProductName,
    //                 selectorEpisodeName,
    //                 selectorPhotoStartDateFrom,
    //                 selectorPhotoStartDateTo,
    //                 selectorSeriesExternalId,
    //                 selectorSeriesName,
    //                 selectorSeasonExternalId,
    //                 selectorSeasonNumberFrom,
    //                 selectorSeasonNumberTo,
    //                 selectorSeasonName,
    //                 selectorGuild,
    //                 selectorFsoId,
    //                 selectorFsoTaxId,
    //                 selectorFsoFirstName,
    //                 selectorFsoLastName,
    //                 selectorFsoSuffix,
    //                 selectorContractedPartyId,
    //                 selectorContractedPartyTaxId,
    //                 selectorContractedPartyFirstName,
    //                 selectorContractedPartyLastName,
    //                 selectorContractedPartySuffix,
    //                 selectorContractedPartyCompanyName,
    //                 selectorPayeeId,
    //                 selectorPayeeTaxId,
    //                 selectorPayeeFirstName,
    //                 selectorPayeeLastName,
    //                 selectorPayeeSuffix,
    //                 selectorPayeeCompanyName,
    //                 selectorJobCode,
    //                 selectorContractLength,
    //                 selectorParticipations,
    //                 selectorResiduals,
    //                 selectorRoyalties
    //             )

    //                 .then(data => {
    //                         console.log("stakeholderListData");
    //                         console.log(data);
    //                         setStakeholderLists(data);
    //                     setSubmitting(false);
    //                     }
    //                 )
    //                 .finally(() => {
    //                     setSubmitting(false);
    //                 })
    //         }
    //     } else {
    //         console.log("search triggered, nothing to search.")
    //     }
    // }

    const fetchStakeholderLists = () => {

        console.log("fetch");

        const request = {

            fileId: selectorFileId,

            recordId: selectorRecordId,

            productId: selectorProductId,

            productName: selectorProductName,

            episodeName: selectorEpisodeName,

            photoStartDateFrom: selectorPhotoStartDateFrom,
            photoStartDateTo: selectorPhotoStartDateTo,

            seriesExternalId: selectorSeriesExternalId,

            seriesName: selectorSeriesName,

            seasonExternalId: selectorSeasonExternalId,

            seasonNumberFrom: selectorSeasonNumberFrom,
            seasonNumberTo: selectorSeasonNumberTo,

            seasonName: selectorSeasonName,

            guild: selectorGuild,

            fsoId: selectorFsoId,

            fsoTaxId: selectorFsoTaxId,

            fsoFirstName: selectorFsoFirstName,

            fsoLastName: selectorFsoLastName,

            fsoSuffix: selectorFsoSuffix,

            contractedPartyId: selectorContractedPartyId,

            contractedPartyTaxId: selectorContractedPartyTaxId,

            contractedPartyFirstName: selectorContractedPartyFirstName,

            contractedPartyLastName: selectorContractedPartyLastName,

            contractedPartySuffix: selectorContractedPartySuffix,

            contractedPartyCompanyName: selectorContractedPartyCompanyName,

            payeeId: selectorPayeeId,

            payeeTaxId: selectorPayeeTaxId,

            payeeFirstName: selectorPayeeFirstName,

            payeeLastName: selectorPayeeLastName,

            payeeSuffix: selectorPayeeSuffix,

            payeeCompanyName: selectorPayeeCompanyName,

            jobCode: selectorJobCode,

            contractLength: selectorContractLength,

            participations: selectorParticipations,

            residuals: selectorResiduals,

            royalties: selectorRoyalties
        };

        console.log(
            JSON.stringify(request, null, 2)
        );

        const hasSearchCriteria = Object.values(request).some(
            value =>
                value !== null &&
                value !== undefined &&
                value !== ''
        );

        if (hasSearchCriteria) {

            // setSubmitting(true);
            dispatchData(changeExternalData({ submitting: true }));

            stakeholderListSearch(request)


                .then(data => {

                    console.log("stakeholderListData");

                    console.log(data);

                    setStakeholderLists(data);

                    if (!data || data.length === 0) {
                        console.log("no matching records found");
                        dispatchData(changeExternalData({ snackbarOpen: true, snackbarSeverity: "info", snackbarMessage: "No matching records found" }));
                    }


                })

                .catch(err => {

                    console.error(err);

                })

                .finally(() => {
                    dispatchData(changeExternalData({ submitting: false }));
                    setSubmitting(false);

                });

        } else {

            console.log(
                "search triggered, nothing to search."
            );
            dispatchData(changeExternalData({ snackbarOpen: true, snackbarSeverity: "warning", snackbarMessage: "No search criteria provided" }));
        }
    };

    const removeStakeholderList = () => {
        deleteStakeholderList(selectedId).then(() => {
            setDeleteOpen(false);
            dispatchData(changeStakeholderList({stakeholderListGridRefresh: true}));
            dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record deleted"}));
        })
    }

    const handleDeleteOpen = () => {
       setDeleteOpen(true);
    };

    function DeleteConfirmationDialog() {

        const handleClickOpen = () => {
            setDeleteOpen(true);
        };

        const handleClose = () => {
            setDeleteOpen(false);
        };


        const handleDelete = () => {
            // Place your delete logic here
            deleteStakeholderList(selectedId).then(() => {
                setDeleteOpen(false);
                dispatchData(changeStakeholderList({stakeholderListGridRefresh: true}));
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record deleted"}));
            })
            console.log('Item deleted');
        };

        return (
                <Dialog
                    open={deleteOpen}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{
                        '& .MuiBackdrop-root': {
                            backgroundColor: 'transparent', // makes backdrop transparent
                            boxShadow: '0 0 10px 5px rgba(0, 0, 0, 0.5)' // custom shadow box effect
                        }
                    }}
                >
                    <DialogTitle id="alert-dialog-title">{"Confirm Delete"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Are you sure you want to delete this item? This action cannot be undone.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>Cancel</Button>
                        <Button onClick={handleDelete} autoFocus color="error">
                            Delete
                        </Button>
                    </DialogActions>
                </Dialog>
        );
    }

    const fetchFileIds = () => {

        getFileIds()
            .then(data => {
                console.log("Guilds");
                console.log(data);
                console.log("Guilds with empty string");
                data.unshift({singleField: ''});
                console.log(data);
                setFileIdDropdown(data);

            })
    }

    const handleAdd = () => {
        dispatchData(changeStakeholderList({id: null,
            fileId: null,
            recordId: null,
            productId: null,
            guild: null,
            fsoId: null,
            fsoTaxId: null,
            fsoFirstName: null,
            fsoLastName: null,
            fsoSuffix: null,
            contractedPartyId: null,
            contractedPartyTaxId: null,
            contractedPartyFirstName: null,
            contractedPartyLastName: null,
            contractedPartySuffix: null,
            contractedPartyCompanyName: null,
            payeeId: null,
            payeeTaxId: null,
            payeeFirstName: null,
            payeeLastName: null,
            payeeSuffix: null,
            payeeCompanyName: null,
            jobCode: null,
            contractLength: null,
            contractDate: null,
            compensation: null,
            pensionedCompensation: null,
            scaleCompensation: null,
            overtimeCompensation: null,
            premiumOvertimeCompensation: null,
            wardrobeCompensation: null,
            allowances: null,
            penalties: null,
            workBeginDate: null,
            daysWorked: null,
            note1: null,
            note2: null,
            note3: null,
            status: null,
            createdOn: null,
            createdBy: null,
            lastModifiedOn: null,
            lastModifiedBy: null,
            taxingLocation: null,
            additFringedCompensation: null,
            advance: null,
            guildEquivalent: null,
            participant: null,
            advance2: null,
            guaranteedDays: null,
            stakeholderListDrawerState: true,
            stakeholderListDrawerMode: "Add"}))
    };


    const handleClickedRow = (stakeholderLists) => {

        console.log('Cast List data from clicked row');
        console.log(stakeholderLists);
        dispatchData(changeStakeholderList({ id: stakeholderLists.id,
            fileId: stakeholderLists.fileId,
            recordId: stakeholderLists.recordId,
            productId: stakeholderLists.productId,
            guild: stakeholderLists.guild,
            fsoId: stakeholderLists.fsoId,
            fsoTaxId: stakeholderLists.fsoTaxId,
            fsoFirstName: stakeholderLists.fsoFirstName,
            fsoLastName: stakeholderLists.fsoLastName,
            fsoSuffix: stakeholderLists.fsoSuffix,
            contractedPartyId: stakeholderLists.contractedPartyId,
            contractedPartyTaxId: stakeholderLists.contractedPartyTaxId,
            contractedPartyFirstName: stakeholderLists.contractedPartyFirstName,
            contractedPartyLastName: stakeholderLists.contractedPartyLastName,
            contractedPartySuffix: stakeholderLists.contractedPartySuffix,
            contractedPartyCompanyName: stakeholderLists.contractedPartyCompanyName,
            payeeId: stakeholderLists.payeeId,
            payeeTaxId: stakeholderLists.payeeTaxId,
            payeeFirstName: stakeholderLists.payeeFirstName,
            payeeLastName: stakeholderLists.payeeLastName,
            payeeSuffix: stakeholderLists.payeeSuffix,
            payeeCompanyName: stakeholderLists.payeeCompanyName,
            jobCode: stakeholderLists.jobCode,
            contractLength: stakeholderLists.contractLength,
            contractDate: stakeholderLists.contractDate,
            compensation: stakeholderLists.compensation,
            pensionedCompensation: stakeholderLists.pensionedCompensation,
            scaleCompensation: stakeholderLists.scaleCompensation,
            overtimeCompensation: stakeholderLists.overtimeCompensation,
            premiumOvertimeCompensation: stakeholderLists.premiumOvertimeCompensation,
            wardrobeCompensation: stakeholderLists.wardrobeCompensation,
            allowances: stakeholderLists.allowances,
            penalties: stakeholderLists.penalties,
            workBeginDate: stakeholderLists.workBeginDate,
            daysWorked: stakeholderLists.daysWorked,
            note1: stakeholderLists.note1,
            note2: stakeholderLists.note2,
            note3: stakeholderLists.note3,
            status: stakeholderLists.status,
            createdOn: stakeholderLists.createdOn,
            createdBy: stakeholderLists.createdBy,
            lastModifiedOn: stakeholderLists.lastModifiedOn,
            lastModifiedBy: stakeholderLists.lastModifiedBy,
            taxingLocation: stakeholderLists.taxingLocation,
            additFringedCompensation: stakeholderLists.additFringedCompensation,
            advance: stakeholderLists.advance,
            guildEquivalent: stakeholderLists.guildEquivalent,
            participant: stakeholderLists.participant,
            advance2: stakeholderLists.advance2,
            guaranteedDays: stakeholderLists.guaranteedDays}));
    };


    // ****************** END FETCH ****************************

    const handleUploadFileDrawer = () => {
        console.log("upload file drawer state changed");
        dispatchData(changeUploadFile({uploadFileDrawerState: true,
            uploadFileDrawerMode: "Stakeholder List"}));
    };
    //
    // useEffect(() => {
    //     console.log("Grid Refresh Triggered");
    //     fetchStakeholderLists();
    //
    //     dispatchData(changeStakeholderList({stakeholderListGridRefresh: false}));
    // }, [useSelector((state) => state.stakeholderListSlc.value.stakeholderListGridRefresh)===true]);

    useEffect(() => {

        if (selectorStakeholderListGridRefresh) {

            fetchStakeholderLists();

            dispatchData(changeStakeholderList({
                stakeholderListGridRefresh: false
            }));
        }

    }, [selectorStakeholderListGridRefresh]);

    useEffect(() => {
        console.log("This is for the File Id dropdown...");
        fetchFileIds();
    }, []);


    function handleProcessFile(){
        setSubmitting(true);
        console.log("This is the file I will submit");
        console.log(selectedFileId);
        processStakeholderList(selectedFileId)
        .then(()=>{setSubmitting(false)})
    };

    const handleFileIdChange = (fileIdEvent) => {
        setSelectedFileId(fileIdEvent.target.value);
        console.log("This is for the selected Value");
        console.log(fileIdEvent.target.value);
    };


    function handleSearch(){
        setShowSearch(!showSearch)
    };



    const gridClear = () => {

        setStakeholderLists([]);
    }


    // ****************** END CRUD ***********************************

    const handleStakeholderListInfo = () => {
        setStakeholderListInfoOpen(true);
    };

    const handleCloseStakeholderListInfo = () => {
        setStakeholderListInfoOpen(false);
    };


    // ****************** BEGIN RETURN ****************************

    return (
        <div style={{ height:800 , width: '100%' }}>
            <Box sx={{height: 80, pt: 1, pl: 3}}>

                <Stack direction="row" sx={{ width: '100%', alignItems: 'center' }} spacing={0}>

                    <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-start', minWidth: 0 }}>
                <Stack direction={"horizontal"}>
                    <Tooltip enterDelay={1000} enterNextDelay={1000} title={"Click for information."}>
                    <h3
                        style={{cursor:'pointer'}}   onClick={() => handleStakeholderListInfo()}
                    >Stakeholder Lists</h3>
                        </Tooltip>
                        <StakeholderListInfoDialogue
                            open={stakeholderListInfoOpen}
                            onClose={handleCloseStakeholderListInfo}
                        />
                    {/*<SearchIcon*/}
                    {/*    sx={{pt: 2, ml: 2}}*/}
                    {/*    color={'primary'}*/}
                    {/*    onClick={handleSearch}*/}
                    {/*/>*/}
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <IconButton
                            color="primary"
                            size="large"               // large icon & hit area
                            onClick={handleSearch}
                            sx={{ ml: 2 }}             // any spacing you want
                        >
                            <SearchIcon fontSize="inherit" />
                        </IconButton>
                    </Box>
                    <Button sx={{pt: 1, ml: 3}}
                            onClick={handleUploadFileDrawer}
                    >Upload</Button>
                </Stack>
                    </Box>

                    <Box sx={{ flex: 0, display: 'flex', justifyContent: 'center', minWidth: 0 }}>
{/*<Box sx={{width:600}}/>*/}
{/*                    <Box sx={{pl: 10}}>*/}
                        <Stack direction={"horizontal"}>
                        <FormControl variant="standard" sx={{pr:1, minWidth: 100 }} >
                            <InputLabel sx={{ ml: 1}} htmlFor="fileId">File ID</InputLabel>
                            <Select
                                labelId="demo-simple-select-filled-fileId"
                                id="fileId"
                                FreeSolo={true}
                                label="fileId"
                                onChange={handleFileIdChange}
                                sx={{ width: 300}}
                            >
                                {fileIdDropdown.map((fileIdItem) =>
                                    <MenuItem  FreeSolo={true} value={fileIdItem.singleField}>{fileIdItem.singleField}</MenuItem>
                                )}
                            </Select>
                        </FormControl>
                    <Button sx={{pt: 2, ml: 1}}
                            onClick={handleProcessFile}
                    >Process</Button>
                        </Stack>
            </Box>
                    <Box sx={{ flex: 1 }} />
                </Stack>

            </Box>
            {showSearch && <StakeholderListSearch
                gridClear = {gridClear}
            />}
            {selectorDrawerState && <StakeholderListDrawer/>}
            {selectorUploadFileDrawerState && <UploadFileDrawer/>}
            {submitting && <LinearIndeterminate/>}
            {gridVisible && <DataGrid
                experimentalFeatures={{ newEditingApi: true }}
                initialState={{
                }}
                aria-label={"StakeholderLists"}
                rows={stakeholderLists}
                disableDensitySelector={true}
                disableColumnSelector={true}
                columns={StakeholderListGridColumns({
                    stakeholderLists,
                    hideActions,
                    onEdit: () => dispatchData(changeStakeholderList({ stakeholderListDrawerState: true, stakeholderListDrawerMode: "Edit" })),
                    onClone: () => dispatchData(changeStakeholderList({ stakeholderListDrawerState: true, stakeholderListDrawerMode: "Clone" })),
                    onDelete: removeStakeholderList
                })}
                onRowClick = {(stakeholderLists)=>handleClickedRow(stakeholderLists.row)}
                density={"compact"}
                pageSize={20}
                rowsPerPageOptions={[20]}
                rowKey={stakeholderList => stakeholderList.id}
                components={{
                    Toolbar: AddFiltersExportToolbar,
                    Footer: CustomFooter,
                }}
                componentsProps={{
                    toolbar: {
                        handleAdd: handleAdd
                    }
                }}
            />}
            <CrudSnackbar/>
            <NoSearchCriteriaSnackbar/>
        </div>

    );

    // ****************** END RETURN ****************************

}



